import PosCartActions from '../../../actions/PosCartActions';
import NotificationActions from '../../../actions/NotificationActions';

import UserStore from '../../../stores/UserStore';

import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';

class AddWholeSaleBulk extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            quantity        : 0,
            pricePerItem    : this.props.item.UnitPrice,
            discountAmount  : 0,
            itemTotalPrice  : this.props.item.UnitPrice
        };

        this.increaseByQty = this.increaseByQty.bind(this);
        this.updateTotal = this.updateTotal.bind(this);
        this.isValid = this.isValid.bind(this);
        this.getPricePerGram = this.getPricePerGram.bind(this);
        this.setPricePerGram = this.setPricePerGram.bind(this);
        this.setItemTotalPrice = this.setItemTotalPrice.bind(this);
    }

    updateTotal() {
        this.setState({
            itemTotalPrice : this.state.quantity * this.state.pricePerItem
        });
    }

    increaseByQty() {
        if (!this.isValid())
            return;

        var item = this.props.item;
        var guest = this.props.guest;

        var quantity = parseInt(this.state.quantity);

        if (this.state.quantity > item.TotalGrams) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Only '+item.TotalGrams+'g left'
            });
        } else {
            item.CannbisProduct  = 'Yes';

            PosCartActions.addBulkItemToCart(
                UserStore.getApiData({
                    ShipmentId  : guest.ShipmentId,
                    SubTotal    : this.state.itemTotalPrice,
                    SerialNo    : item.SerialNo,
                    Grouping    : 'No',
                    ProdId      : item.ProductId,
                    AvailOz     : item.TotalOz,
                    UnitPrice   : this.state.itemTotalPrice,
                    OrderId     : 0,
                    DiscountAmt : this.state.discountAmount,
                    Comments    : '',
                    InvId       : 0,
                    Weight      : quantity
                }),
                guest,
                item
            );

            this.props.onClose();


            return;
            var tmpItem = this.props.item;
            tmpItem.DiscountAmount = this.state.discountAmount;
            tmpItem.UnitPrice      = this.state.pricePerItem;

            PosCartActions.addItemToCart(tmpItem, this.props.guest, this.state.quantity);
        }
    }

    isValid() {
        if (this.state.quantity === 0 || this.state.quantity.length < 1)
            return false;

        if (this.state.pricePerItem === 0 || this.state.pricePerItem.length < 1)
            return false;

        return true;
    }

    getPricePerGram() {
        var self = this;

        var query = $('#last-four').val();

        var formData = UserStore.getApiData();

        AjaxPromises.POST(PosEndPoints.GET_BULK_BY_WEIGHT, UserStore.getApiData({
            Guest_id : this.props.guest.Guest_id,
            Wgt : this.state.quantity,
            ProductId : this.props.item.ProductId
        })).then(res => {


        });
        
    }

    setPricePerGram(e) {
        this.setState({
            pricePerItem : e.target.value,
            itemTotalPrice : e.target.value * this.state.quantity
        });
    }

    setItemTotalPrice(e) {
        this.setState({
            pricePerItem : e.target.value / this.state.quantity,
            itemTotalPrice : e.target.value
        });
    }

    render() {
        var self = this;

        var item      = this.props.item;
        var guest     = this.props.guest;
        var isValid   = this.isValid();

        return (

            <div className='popup popup__transparent'>
                <div className='popup__content add-wholesale'>
                    <div className='popup-header'>
                        Add Wholesale Bulk

                        <div
                            className='popup-close'
                            onClick={() => { this.props.onClose(); }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <div className='add-wholesale__title'>
                        {item.ProductDesc}
                    </div>

                    <input
                        type='number'
                        id='last-four'
                        value={this.state.quantity}
                        onChange={(e) => { this.setState({ quantity : e.target.value.replace(/[^0-9.]/g, '')}, () => { self.updateTotal() }); }} />

                    <div className='add-wholesale__label'>
                        Grams
                    </div>

                    <input
                        type='number'
                        value={this.state.pricePerItem}
                        onChange={this.setPricePerGram} />

                    <div className='add-wholesale__label'>
                        Price per Gram
                    </div>

                    <input
                        type='number'
                        value={this.state.itemTotalPrice}
                        onChange={this.setItemTotalPrice} />

                    <div className='add-wholesale__label'>
                        Item Total Price
                    </div>

                    <input
                        type='number'
                        value={this.state.discountAmount}
                        onChange={(e) => { this.setState({ discountAmount : e.target.value }); }} />

                    <div className='add-wholesale__label'>
                        Discount Amount
                    </div>

                    <div
                        className={'add-wholesale__save '+(!isValid ? 'btn-green__disabled' : '')}
                        onClick={this.increaseByQty}>

                        ADD
                    </div>
                </div>
            </div>

        );
    }
}

export default AddWholeSaleBulk;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/selected/AddWholesaleBulk.react.jsx